export default __webpack_public_path__ + "static/media/img_company_header39.04bfd2b9.png";